





























import Vue from 'vue';
import SearchBanner from './components/banner/SearchBanner.vue';
import SearchBannerForm from './components/banner/form/SearchBannerForm.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'RestaurantsSearchBanner',
  components: {
    SearchBanner,
    SearchBannerForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    cityUnique: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('restaurantsSearchBanner', {
      loading: 'isLoading',
      image: 'image',
      date: 'dateData',
      city: 'cityData',
      amount: 'amountData',
    }),
  },
  methods: {
    handleSubmit() {
      const queryParams = new URLSearchParams({
        people: this.amount.toString(),
      });

      if (this.date?.date) {
        queryParams.append('date', this.date.date);
      }

      if (this.date?.dateShortcut) {
        queryParams.append('date_shortcut', this.date.dateShortcut);
      }

      const url = `/restaurants/${this.city.slug}/?${queryParams.toString()}`;
      window.location.href = url;
    },
  },
  mounted() {
    this.$store.dispatch('restaurantsSearchBanner/fetchInitialData', this.cityUnique);
  },
});
